/* specs/03-collection.md — AJAX "Load more" pagination */

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-load-more]');
  if (!button) return;

  const nextUrl = button.dataset.nextUrl;
  if (!nextUrl) return;

  button.disabled = true;
  const label = button.textContent;
  button.textContent = 'Loading…';

  fetch(nextUrl)
    .then((response) => response.text())
    .then((text) => {
      const html = new DOMParser().parseFromString(text, 'text/html');
      const newGrid = html.querySelector('#CollectionGrid');
      const grid = document.querySelector('#CollectionGrid');
      if (newGrid && grid) {
        grid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
      }
      const newButtonWrap = html.querySelector('.collection-load-more');
      const currentWrap = button.closest('.collection-load-more');
      if (newButtonWrap && currentWrap) {
        currentWrap.replaceWith(newButtonWrap);
      } else if (currentWrap) {
        currentWrap.remove();
      }
    })
    .catch(() => {
      button.disabled = false;
      button.textContent = label;
    });
});
